import { render, staticRenderFns } from "./FeeCheckbox.vue?vue&type=template&id=2540e8b9&scoped=true&"
import script from "./FeeCheckbox.vue?vue&type=script&lang=js&"
export * from "./FeeCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./FeeCheckbox.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FeeCheckbox.vue?vue&type=style&index=1&id=2540e8b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2540e8b9",
  null
  
)

export default component.exports